import type { EcomData, EcomDataMultiple, EcomProduct } from '~/constants/types/product';

export default function useProductService() {
  const { centraPost } = useApiFetch();
  const fetchProduct = async(ecomId: number | string, wpId: number | null = null) => {
    const contentData = null;
    if (wpId) {
      // @todo - add wp data? - no product uses it
    }
    const product = await centraPost<EcomData>(`/products/${ecomId}`);
    if (product) {
      return { ecomData: product.product, contentData };
    }
    throw new Error();
  };

  const fetchProducts = async(filters: object) => {
    filters = {
      ...filters,
      var_channel: ['Webshop'],
    };
    const body = {
      ...filters,
      relatedProducts: true,
    };

    const data = await centraPost<EcomDataMultiple>('/products', body);
    if (data) {
      const filteredProducts = data.products.filter((p: EcomProduct) => p.name);
      return { products: filteredProducts, data };
    } else {
      console.error('Couldnt load products');
    }
  };

  return {
    fetchProduct,
    fetchProducts,
  };
}
